import httpServe from '../http/http'
import { APPLICATION_ID } from '../config/config'

let request = {}

/**
 * 字典码查询
 * @param code
 * @returns {Promise.<void>}
 */
request.getCode = async function (code) {
  let url = httpServe.getApiUrl('/pub/loadcode?groups=' + code)
  let res = await httpServe.ajaxGet(url, {}, true)
  return res['data']
}

request.loadcode = request.getCode

// 获取所有菜单权限
request.queryAuths = async function () {
  let url = httpServe.getApiUrl('/api/auth/findAuths')
  let res = await httpServe.ajaxPost(url, { applicationId: 1 }, true)
  return res['data']
}
// 获取菜单权限
request.queryUserAuths = async function () {
  let url = httpServe.getApiUrl('/api/auth/findUserAuth')
  let res = await httpServe.ajaxGet(url, {}, true)
  return res['data']
}
// 退出登录
request.logout = async function () {
  let url = httpServe.getApiUrl('/pub/user/logout');
  let res = await httpServe.ajaxGet(url, {}, true)
  return res['data'];
}
//下载文件
request.downloadFile = function (data, filename = false) {
  if (!filename) {
    filename = httpServe.getFileName(data)
  }
  if (!filename) {
    filename = 'excel.xls'
  }
  httpServe.download(data, filename)
}

// 角色管理 ###########################
/**
 * 分页查询角色
 */
request.queryRole = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/queryRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 添加角色
 * @param {Object} data { name, content, editable, authIds }
 */
request.saveRole = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/saveRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 保存用户角色
 * @param {Object} data { userId, roleIds }
 */
request.saveUserRole = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/saveUserRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 批量保存用户角色
 * @param {Object} data { userIds, roleIds }
 */
request.batchSaveUserRole = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/batchSaveUserRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 删除角色
 * @param {Object} data { roleId }
 */
request.deleteRole = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/deleteRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 查询角色详情
 * @param {Object} data { roleId }
 */
request.findRoleById = async function (data) {
  const url = httpServe.getApiUrl('/api/auth/findRoleById')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 查询权限列表
 * @param {Object} data { applicationId }
 */
request.findAuths = async function (data = {}) {
  data.applicationId = APPLICATION_ID
  const url = httpServe.getApiUrl('/api/auth/findAuths')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}

// 员工管理 ###########################
/**
 * 分页查询用户
 */
request.queryUsers = async function (data) {
  const url = httpServe.getApiUrl('/api/user/queryUsers')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 设置用户状态
 * @param {Object} data { userId, status }
 */
request.setUserStatus = async function (data) {
  const url = httpServe.getApiUrl('/api/user/setUserStatus')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 批量设置用户状态
 * @param {Object} data { userIds, status }
 */
request.batchSetUserStatus = async function (data) {
  const url = httpServe.getApiUrl('/api/user/batchSetBaseStatus')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 添加用户
 * @param {Object} data { username, password, name }
 */
request.addUser = async function (data) {
  const url = httpServe.getApiUrl('/api/user/addUser')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 删除员工
 * @param {Object} data { userIds }
 */
request.batchRemoveUser = async function (data) {
  const url = httpServe.getApiUrl('/api/user/batchRemoveUser')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 更新用户信息
 * @param {Object} data
 */
request.updateUserInfo = async function (data) {
  const url = httpServe.getApiUrl('/api/user/updateUserInfo')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 根据角色查询员工
 * @param {Object} data { roleIds, pageIndex, pageSize }
 */
request.queryUsersByRole = async function (data) {
  const url = httpServe.getApiUrl('/api/user/queryUsersByRole')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
/**
 * 修改密码
 * @param {Object} data { userId, newPassword }
 */
request.changeMyPassword = async function (data) {
  const url = httpServe.getApiUrl('/api/user/changeMyPassword')
  const res = await httpServe.ajaxPost(url, data, true)
  return res['data']
}
// 商品管理 ###########################
//查询商品
request.queryShopProduct = async function (data) {
  const url = httpServe.getApiUrl('/open/goods/query')
  const res = await httpServe.ajaxPost(url, data, false)
  return res['data']
}
export default request
